import { __decorate, __metadata } from "tslib";
import { Serialize, Type } from '@ftr/serialization';
import { IsArray, IsBoolean, IsOptional, IsUUID, Matches, ValidateIf, ValidateNested } from 'class-validator';
import { LineItemRequest } from './LineItemRequest';
import { OrderAttachmentRequest } from './OrderAttachmentRequest';
/**
 * Request to resubmit an order
 */
export class ResubmitOrderRequest {
    constructor(orderId, lineItem, paymentToken, saveCreditOrDebitCard, cardId, courtSystemId, attachments, costWaiverRequested) {
        this.orderId = orderId;
        this.lineItem = lineItem;
        this.paymentToken = paymentToken;
        this.saveCreditOrDebitCard = saveCreditOrDebitCard;
        this.cardId = cardId;
        this.courtSystemId = courtSystemId;
        this.attachments = attachments;
        this.costWaiverRequested = costWaiverRequested;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ResubmitOrderRequest.prototype, "orderId", void 0);
__decorate([
    ValidateNested(),
    Serialize(),
    __metadata("design:type", LineItemRequest
    /**
     * A third party payment token that authorises us to charge the customer.
     * Currently this is the Stripe payment token that gets generated when a customer enters
     * their credit card details and authorises the charge.
     */
    )
], ResubmitOrderRequest.prototype, "lineItem", void 0);
__decorate([
    IsOptional(),
    Matches(/^tok_.+/),
    __metadata("design:type", Object)
], ResubmitOrderRequest.prototype, "paymentToken", void 0);
__decorate([
    IsBoolean(),
    ValidateIf(o => o.paymentToken),
    __metadata("design:type", Object)
], ResubmitOrderRequest.prototype, "saveCreditOrDebitCard", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], ResubmitOrderRequest.prototype, "cardId", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ResubmitOrderRequest.prototype, "courtSystemId", void 0);
__decorate([
    Type(() => OrderAttachmentRequest),
    IsArray(),
    __metadata("design:type", Array)
], ResubmitOrderRequest.prototype, "attachments", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ResubmitOrderRequest.prototype, "costWaiverRequested", void 0);
